jQuery(($) => {

    $.each($('.plyr'), function () {
        var player = new Plyr(this);
    });

    if ($(".image-cards .video-active")) {
        $('.image-cards .watch-video').click(function (e) {
            e.preventDefault()
            $(this).parents(".image-cards").find(".video-active img").click();
        });
    }
});
